// extracted by mini-css-extract-plugin
export var centerText = "_6f-8";
export var container = "_6f-0";
export var doughnutContainer = "_6f-7";
export var legend = "_6f-a";
export var legendItemColorDisplay = "_6f-b";
export var legendItemLabel = "_6f-d";
export var legendItemValue = "_6f-c";
export var lg = "_6f-5";
export var maxWidth = "_6f-9";
export var md = "_6f-4";
export var responsive = "_6f-6";
export var sm = "_6f-3";
export var xs = "_6f-2";
export var xxs = "_6f-1";